<template>
    <div>
        <card-header icon="fa-book-reader" title="Study Log" />

        <card-body>
            <webix-study-log v-if="viewMode == 'schedule'" :userId="props.userId" />
            <custom-timeline-view v-else :userId="props.userId" />
        </card-body>

        <card-footer>
            <span v-if="viewMode == 'schedule'">
                <i class="fal fa-info-circle mr-2"></i>
                Click on a study session to view details.
            </span>
            <span v-else>
                <i class="fal fa-info-circle mr-2"></i>
                Hover over a study session to view details.
            </span>
            <span class="ml-3">
                <b-radio v-model="viewMode" native-value="schedule">Schedule View</b-radio>
                <b-radio v-model="viewMode" native-value="gantt">Timeline View</b-radio>
            </span>
        </card-footer>
    </div>
</template>

<script>
import CardHeader from "@/TIER/components/CardHeader";
import CardBody from "@/TIER/components/CardBody";
import CardFooter from "@/TIER/components/CardFooter";

import WebixStudyLog from "./Webix/WebixStudyLog";
import CustomTimelineView from "./CustomTimelineView";

export default {
    components: { CardFooter, CardBody, CardHeader, WebixStudyLog, CustomTimelineView },
    props: ['card', 'props', 'child'],
    data() {
        return {
            viewMode: 'schedule',
        };
    },
    methods: {
    },
    watch: {
    },
    mounted: function () {
    }
}
</script>

<style scoped lang="css"></style>